module.exports = __webpack_public_path__ + "static/media/dolakha3.3beb4981.ogg";